export function assertUnreachable(_x: never): never {
  throw new Error(`I didn't expect to reach this point!`);
}

export function nameof<T>(key: keyof T & string): string {
  return key;
}
